import { render, staticRenderFns } from "./StudentTaskText.vue?vue&type=template&id=02bf29d2&"
import script from "./StudentTaskText.vue?vue&type=script&lang=js&"
export * from "./StudentTaskText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports